<template>
    <div>
        <h1>This page is protected by auth</h1>
    </div>
</template>

<script>
    //uncomment for vuex state management
    //import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

    export default {
        //Your local variables for use in the component
        data() {
            return {
                email: "",
                password: ""
            }
        },
        //calculated values, auto reactive
        //functionName: function(){}
        //functionName: { get: function() {}, set: function(value){}}
        computed: {},
        //perform actions, not reactive to variables used
        //functionName: function(arg1,arg2){}
        methods: {
            login: function () {
                let email = this.email
                let password = this.password
                this.$store.dispatch('login', { email, password })
                    .then(() => this.$router.push('/'))
                    .catch(err => alert(err))
            }
        },
        /*  data passed in from external
        propName: {
            type: Number,
            default: 42,
            required: false
        }
        */
        props: {},
        /* other components need
          you need to import the component first
          'component-a': ComponentA,
        */
        components: {}
    };
</script>
